<template>
  <v-container
    id="profileData"
    fluid
    tag="section"
  >
    <base-material-card
      color="secondary"
      class="profile-section "
      style="margin-top: 40px"
    >
      <template v-slot:heading>
        <v-tabs
          v-model="tabs"
          background-color="transparent"
          slider-color="white"
        >
          <v-tab
            id="tab-home"
            class="mr-3"
          >
            <v-icon class="mr-2">mdi-timeline-clock-outline</v-icon>
            {{ $t("timeline") }}
          </v-tab>
          <v-tab
            id="tab-order"
            class="mr-3"
          >
            <v-icon class="mr-2">mdi-cart-outline</v-icon>
            {{ $t("orders") }}
          </v-tab>
          <v-tab
            id="tab-certificate"
            class="mr-3"
          >
            <v-icon class="mr-2">mdi-certificate-outline</v-icon>
            {{ $t("certificates") }}
          </v-tab>
          <v-tab
            id="tab-tessere"
            class="mr-3"
          >
            <v-icon class="mr-2">mdi-account-card-details-outline</v-icon>
            {{ $t("affiliation_cards") }}
          </v-tab>
          <v-tab
            id="tab-profile"
            class="mr-3"
          >
            <v-icon class="mr-2">mdi-account-edit</v-icon>
            {{ $t("profile") }}
          </v-tab>
          <v-tab
            id="tab-signature"
            class="mr-3"
          >
            <v-icon class="mr-2">mdi-draw</v-icon>
            {{ $t("signature") }}
          </v-tab>
          <v-tab
            v-if="notifyData"
            id="tab-notify"
            class="mr-3"
          >
            <v-icon class="mr-2">mdi-bell</v-icon>
            {{ $t("notify_rules") }}
          </v-tab>
        </v-tabs>
      </template>
      <v-tabs-items
        v-model="tabs"
        class="transparent tabs-container"
      >
        <v-tab-item>
          <user-time-line :masterId="masterId"></user-time-line>
        </v-tab-item>
        <v-tab-item>
          <list-ordini
            :card="false"
            mode="USER"
            :masterId="masterId"
            header-color="azure"
          ></list-ordini>
        </v-tab-item>
        <v-tab-item>
          <list-certificati
            :card="false"
            :masterId="masterId"
            header-color="azure"
          ></list-certificati>
        </v-tab-item>
        <v-tab-item>
          <list-tessere-table
            :masterId="masterId"
            header-color="azure"
          ></list-tessere-table>
        </v-tab-item>
        <v-tab-item>
          <user-edit-profile
            @isUpdated="emitUpdated"
            type="plain"
            paramsMode="EDIT"
            :paramsMasterId="masterId"
            paramsType="plain"
            header-color="azure"
          ></user-edit-profile>
        </v-tab-item>
        <v-tab-item>
          <user-edit-signature
            :masterId="masterId"
            header-color="azure"
          ></user-edit-signature>
        </v-tab-item>
        <v-tab-item v-if="notifyData">
          <user-edit-auto-notify
            :masterId="masterId"
            header-color="azure"
          ></user-edit-auto-notify>
        </v-tab-item>
      </v-tabs-items>
    </base-material-card>
  </v-container>
</template>

<script>
import userEditProfile from "@/widget/userEditProfile.vue";
import userEditSignature from "@/widget/userEditSignature.vue";
import userEditAutoNotify from "@/widget/userEditAutoNotify.vue";
import userTimeLine from "@/widget/userTimeLine.vue";
import listCertificati from "@/widget/listCertificati.vue";
import listTessereTable from "@/widget/listTessereTable.vue";
import listOrdini from "@/widget/listOrdini.vue";
import PagesPlanCard from "@/views/pages/components/PlanCard";

export default {
  name: "profile-data",
  components: {
    PagesPlanCard,
    userEditProfile,
    userEditSignature,
    userEditAutoNotify,
    listCertificati,
    listTessereTable,
    listOrdini,
    userTimeLine,
  },
  props: {
    masterId: null,
    startTab: null,
  },
  data() {
    return {
      tabs: 0,
      notifyData: false,
    };
  },
  computed: {},
  methods: {
    emitUpdated: function (data) {
      this.$emit("isUpdated", "true");
    },
    onSelect: function (items) {
      this.selected = items;
    },
    onResponsiveInverted() {
      if (window.innerWidth < 768) {
        this.responsive = true;
      } else {
        this.responsive = false;
      }
    },
  },
  mounted() {
    let _ = this;
    this.onResponsiveInverted();
    this.tabs = this.startTab;
    this.notifyData = false;
    window.addEventListener("resize", this.onResponsiveInverted);
    if (
      window.systemData &&
      window.systemData.modules &&
      window.systemData.modules.includes("notify")
    ) {
      this.chiamataAxios(
        "GET",
        "/auth/notify/getUserAutoNotifyRoles/" + _.masterId
      ).then((response) => {
        _.notifyData = response && response.data && response.data.length > 0;
      });
    }
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResponsiveInverted);
  },
};
</script>
<style scoped lang="scss">
#profileData {
  padding-left: 5px;
  padding-right: 5px;
}
.text-right {
  display: flex;
}
.tabs-container {
  margin-top: 20px;
}
</style>
